import ContactSection from '../components/ContactSection';
import { psiTokens } from '../theme/psiTheme';
import { usePageMeta } from '../hooks/usePageMeta';

export default function ContactPage() {
  usePageMeta(
    'Contact',
    'Get in touch with PSI to start a conversation about your training or consulting needs, a one-time session or an ongoing program.'
  );

  return (
    <ContactSection
      backgroundColor={psiTokens.background.primary}
      description="PSI works with organizations seeking real, lasting problem-solving capacity."
    />
  );
}
